import React, { useState } from "react";
import { motion } from "framer-motion";
import "../GuidedTour.css";

export default function Step5StartGrading({
  onComplete,
  studentName,
  testName,
}) {
  const [isGrading, setIsGrading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Show grading animation
    setIsGrading(true);

    // Simulate grading (2 seconds)
    setTimeout(() => {
      onComplete();
    }, 2000);
  };

  if (isGrading) {
    return (
      <div className="tour-step-container">
        <motion.div
          className="tour-step-full-card"
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
        >
          <div className="tour-step-header" style={{ textAlign: "center" }}>
            <motion.div
              className="tour-step-icon-large"
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            >
              <i className="fa-solid fa-gears"></i>
            </motion.div>
            <h2 className="tour-step-title">AI is Grading...</h2>
            <p className="tour-step-description">
              Our AI is analyzing the answer paper and providing detailed
              feedback.
            </p>
          </div>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="tour-step-container">
      <motion.div
        className="tour-step-full-card"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        {/* Step Header */}
        <div className="tour-step-header">
          <div className="tour-step-icon-large">
            <i className="fa-solid fa-wand-magic-sparkles"></i>
          </div>
          <h2 className="tour-step-title">Start Grading</h2>
          <p className="tour-step-description">
            Click the button below to start AI-powered grading for {studentName}
            's answer paper.
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="tour-step-form">
          {/* Info Section */}
          <div className="demo-info-section">
            <div className="info-header">
              <i className="fa-solid fa-file-alt"></i>
              Ready to Grade
            </div>
            <div
              style={{
                padding: "1rem",
                background: "white",
                borderRadius: "8px",
                border: "2px solid #e2e8f0",
              }}
            >
              <div
                style={{
                  fontWeight: "600",
                  color: "#2d3748",
                  marginBottom: "0.5rem",
                }}
              >
                Student: {studentName}
              </div>
              <div style={{ fontSize: "0.9rem", color: "#64748b" }}>
                Test: {testName} | Max Score: 30 points
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="demo-form-actions">
            <button type="submit" className="demo-submit-btn">
              <i className="fa-solid fa-wand-magic-sparkles"></i>
              Start Grading
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
